import 'intersection-observer';

import gsap, {Power2, Power3} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";


export class VerticalAnimatedListModule {
    private counterElement: any;
    private counterEndValue: number | any = 0;
    private counterStartValue: number = 0;

    constructor() {
    }

    init() {
        let options = {
            rootMargin: '0px 30px 0px 0px',
            threshold: 0.8
        };
        const observer = new window.IntersectionObserver(entries => {
            entries.forEach((entry) => {
                if (entry.target.classList.contains('is-visible')) return;
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add('is-visible');
                    this.counterElement = entry.target.querySelector('.counter__item');
                    this.counterEndValue = entry.target.querySelector('.counter__item')?.getAttribute('data-counter') ? entry.target.querySelector('.counter__item')?.getAttribute('data-counter') : 0;
                    this.animateValue(this.counterElement, this.counterStartValue, this.counterEndValue, 1000);
                } else {
                    entry.target.classList.remove('is-visible');
                }
            });
        }, options);

        const elements = Array.prototype.slice.call(document.querySelectorAll('.vertical__animated__item:not(.is-visible)'));
        elements.forEach(el => {
            observer.observe(el);
        });

    }

    animateValue(obj: any, start: number, end: number, duration: number) {
        let startTimestamp: any = null;
        const step = (timestamp: any) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

}


gsap.registerPlugin(ScrollTrigger);

export class TextAnimationModule {

    constructor() {
    }

    init() {
        if(window.innerWidth < 1025) return;

        const tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: "#text__animation",
                start: "-1100px", // When the top of the trigger reaches the top of the viewport
                end: '400px',
                scrub: 0.5,
                // markers: true
            }
        });

        const textAnimation = document.querySelector('#text__animation');

        if (!textAnimation) {
            return;
        }

        const animationH3 = textAnimation.querySelector('.headline, #text__animation svg')
        const verticalItems = textAnimation.querySelectorAll('.vertical__image__item');
        const headlineOffset = textAnimation.getAttribute('data-headline-initial-offset') || 0;
        const headlineOffsetVertical = textAnimation.getAttribute('data-headline-initial-offset-vertical') || 0;
        gsap.set(animationH3, {scale: 820,zIndex:-1,force3D: false, x: headlineOffset, y: headlineOffsetVertical});
        // tl2.to(animationH3, {scale: 1, duration: 22,delay:-1,force3D: false, x: 0});
        // tl2.from(verticalItems, {opacity: 0, stagger: 0.5, duration: 0.3, force3D: true});

        tl2.to(animationH3, {scale: 1, duration: 11,delay:-2,force3D: false, x: 0, y: 0, ease: 'power3.out'});

        const tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('#text__animation .vertical__image__item'),
                start: "-900px",
                end: '-300px',
                scrub: 0.5,
            }

        });

        tl3.from(verticalItems, {opacity: 0, stagger: 1, duration: 2.5, force3D: true});

        // verticalItems.forEach((item: HTMLElement, index) => {
        //    const texts = item.querySelectorAll('h5,.h5,p');
        //    console.log(item);
        //     tl3.from(texts, {x: index % 2 === 0 ? -100 : 100, stagger: 1, duration: 2.5, force3D: true});
        // });

        const circle = document.querySelector('.section__experience--circle')
        const wrapper:HTMLElement = circle.closest('.grid__wrapper');
        // const circleAnimationTimeline = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: document.querySelector('.section-experience'),
        //         // start: wrapper.offsetTop + "px center",
        //         // end: (wrapper.clientHeight + wrapper.offsetTop) + 'px center',
        //         start: "0px 20%",
        //         // end: 'bottom center',
        //         end: (wrapper.clientHeight + 600) + 'px center',
        //         // markers: true,
        //         scrub: 0.5,
        //     }
        // });

        const items:NodeList = wrapper.querySelectorAll('.grid__item');

        const firstItem:HTMLElement = items[0] as HTMLElement;

        // circleAnimationTimeline.from(circle, {opacity: 0, x:0, y: firstItem.offsetTop});
        // circleAnimationTimeline.to(circle, {opacity: 1, duration: 2});

        let lastX = 0;
        let lastY = firstItem.offsetTop;

        items.forEach((elem: HTMLElement, index) => {
            if (index === 0) return;
            // console.log({x: index % 2 === 1 ? -500 : 0, y: elem.offsetTop + (index % 2 === 1 ? 180 : 0), scale:4, duration: index + 1});
            // circleAnimationTimeline.to(circle, {x: index % 2 === 1 ? -500 : 0, y: elem.offsetTop + (index % 2 === 1 ? 180 : 0), scale:4, duration: index + 1});
            const newX = index % 2 === 1 ? -500 : 0;
            const newY = elem.offsetTop;// + (index % 2 === 1 ? 180 : 0);
            // circleAnimationTimeline.to(circle, {x: -250, y: lastY + ((newY - lastY) / 2), scale:1, duration: 0.5});
            // circleAnimationTimeline.to(circle, {x: newX, y: newY, duration: 1.5});
            lastX = newX;
            lastY = newY
        });

        // const lastItem:HTMLElement = items[items.length - 1] as HTMLElement;

        // circleAnimationTimeline.to(circle, {x: -4000, y: lastItem.offsetTop + 300, scale:1, duration: items.length + 1});
        // circleAnimationTimeline.to(circle, {opacity: 0, scale:1, duration: items.length + 1});
        // circleAnimationTimeline.to(circle, {opacity: 0, scale:0.5, duration: 2});

        // circleAnimationTimeline.to(circle, {x: 800, y: 230,scale:4, duration: 3});
        // circleAnimationTimeline.to(circle, {x: 350, y: 480, scale: 2,duration: 4});
        // circleAnimationTimeline.to(circle, {x: 800, y: 980, scale: 4,duration: 5});
        // circleAnimationTimeline.to(circle, {x: 100, y: 1100, scale: 4,duration: 6});
    }


}
